<template>
  <nx-board-selector
      :label="label"
      :data-vv-name="name"
      :data-vv-scope="scope"
      :data-vv-as="label"
      :value="value"
      v-validate:value="validation"
      data-vv-validate-on="input"
      :error-messages="errorMessages"
      :required="required"
      :disabled="disabled"
      @input="onInput"
      @blur="onBlur"
      @focus="onFocus"
      v-bind="$attrs"
  ></nx-board-selector>
</template>

<script>
import FormElement from '@/modules/form/mixins/form-element';
import Selector from './Selector';

/**
 * Board selector module.
 *
 * @property {string} [identifier] String to use as identifier for this module.
 * @property {[]} [value] Array of initial selected boards.
 */
export default {
  name: 'nx-board-form-selector',
  mixins: [FormElement],
  components: {
    [Selector.name]: Selector,
  },
  props: {
    value: {
      type: [Object, String, Number],
    },
  },
  methods: {
    onInput(boardId, board = null) {
      this.$parentForm.updateField(this.name, boardId, board);
      this.$emit('input', boardId, board);
    },
    onBlur(board) {
      this.flags.focused = false;
      this.$emit('blur', board);
    },
  },
};
</script>
